"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _AbstractClassException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractClassException"));

var _AbstractMethodException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractMethodException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class is used for fetching article data from IKEA Item Retail Service
 *
 * @abstract
 */
var AbstractArticleService = /*#__PURE__*/function (_AbstractService) {
  _inherits(AbstractArticleService, _AbstractService);

  var _super = _createSuper(AbstractArticleService);

  /**
   * Class constructor.
   */
  function AbstractArticleService() {
    var _this;

    _classCallCheck(this, AbstractArticleService);

    _this = _super.call(this);

    if (_this.constructor === _AbstractService2.default) {
      throw new _AbstractClassException.default();
    }

    return _this;
  }
  /**
   * Fetches items from RetailItemComm.
   *
   * @abstract
   * @example retailItemService.getItems([ { type: 'ART', id: '123456' }, { type: 'ART', id: '654321' } ]).then(items => {
   * // Handle items
   * }).catch(error => {
   * // Handle error
   * });
   * @param {ArticleServiceConfig} config Service config.
   * @param {Object[]} items Array of items.
   * @return {Promise} Promise object.
   */


  _createClass(AbstractArticleService, [{
    key: "getItems",
    value: function getItems() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Returns the parser used by the service. To enable cacheRawData.
     *
     * @abstract
     * @param {ArticleServiceConfig} config Service config.
     * @return {Function} class.
     */

  }, {
    key: "getParser",
    value: function getParser() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Returns item sets based on the maximum allowed items per request for RetailItemComm.
     *
     * @param {Object} options Options.
     * @param {Object[]} options.items Array of items to parse.
     * @param {Boolean} [options.avoidOneItem=true] TRUE to avoid one item by adding an empty item as this causes problems in IRW and NWP.
     * @return {Object[]} Item sets.
     */

  }, {
    key: "_getItemSets",
    value: function _getItemSets(_ref) {
      var items = _ref.items,
          _ref$avoidOneItem = _ref.avoidOneItem,
          avoidOneItem = _ref$avoidOneItem === void 0 ? true : _ref$avoidOneItem;

      var maxItemsPerRequest = this._getMaxItemsPerRequest();

      var sets = [[]];
      var currentSet = sets[0];

      for (var i = 0, max = items.length; i < max; i++) {
        if (currentSet.length === maxItemsPerRequest) {
          currentSet = [];
          sets.push(currentSet);
        }

        if (items[i].id && items[i].type) {
          currentSet.push(items[i]);
        }
      }

      if (avoidOneItem && currentSet.length === 1) {
        currentSet.push({
          type: 'ART',
          id: '0'
        });
      }

      return sets;
    }
    /**
     * Returns the maximum allowed items per request for RetailItemComm.
     *
     * @return {Number} Maximum allowed items per request.
     */

  }, {
    key: "_getMaxItemsPerRequest",
    value: function _getMaxItemsPerRequest() {
      return 100;
    }
    /**
     * Sorts items.
     *
     * @param {Object[]} items Array of items to sort.
     * @return {Object[]} Sorted items.
     */

  }, {
    key: "_sortItemsById",
    value: function _sortItemsById(items) {
      return items.slice().sort(function (a, b) {
        return a.id - b.id;
      });
    }
    /**
     * Cleans ids from underscore in items.
     *
     * @param {Object[]} items Items to clean.
     */

  }, {
    key: "_cleanIdFromUnderscore",
    value: function _cleanIdFromUnderscore(items) {
      var _iterator = _createForOfIteratorHelper(items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.id.includes('_')) {
            item.id = item.id.split('_')[1];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return AbstractArticleService;
}(_AbstractService2.default);

exports.default = AbstractArticleService;